import content from '../../../data/content.json';

export default function ServicesSection() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-10 bg-teal-500"></div>
            <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">{content.services.sectionSubtitle}</span>
            <div className="h-px w-10 bg-teal-500"></div>
          </div>
          <h3
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {content.services.sectionTitle}
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {content.services.sectionDescription}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 mb-12">
          {content.services.list.map((service, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl p-6 border ${service.borderColor} hover:-translate-y-1 hover:shadow-lg transition-all duration-300 group cursor-default flex gap-5 items-start`}
            >
              <div className="flex-shrink-0 relative">
                <div className={`w-14 h-14 flex items-center justify-center ${service.color} rounded-xl`}>
                  <i className={`${service.icon} text-2xl ${service.iconColor}`}></i>
                </div>
                <div className="absolute -top-2 -left-2 w-6 h-6 bg-teal-600 text-white text-xs font-bold rounded-full flex items-center justify-center shadow-sm">
                  {i + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {service.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {service.tags.map((tag, j) => (
                    <span key={j} className={`text-xs px-3 py-1 ${service.color} ${service.iconColor} rounded-full font-medium`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bridging the Gap Banner */}
        <div className="bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-teal-400 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-teal-400 to-transparent"></div>
          </div>
          <div className="relative z-10">
            <p
              className="text-2xl md:text-3xl font-semibold text-white italic mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {content.brand.slogan}
            </p>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-6">
              {content.brand.shortMission}
            </p>
            <button
              onClick={() => scrollToSection('get-help')}
              className="px-10 py-4 bg-teal-600 text-white font-semibold rounded-xl hover:bg-teal-500 transition-colors whitespace-nowrap cursor-pointer text-lg"
            >
              <i className="ri-hand-heart-line mr-2"></i>
              Request Support Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
